
import Fact from "./fact";



function FactList({ facts, setFacts }) {

    if (facts.length === 0) {
        return <p>There are no facts for this category yet. Add your own.</p>
    } else {
        return (
            <>
                {/* <p>Fact List</p> */}
                <p>There are currently {facts.length} facts in the database</p>
                <section>
                <ul id="facts-list">
                    {
                        facts.map((fact)=>( 
                            // <li className="manual-li">{fact.text}</li>
                            // "hello\n"
                            <Fact key={fact.id} fact={fact} setFacts={setFacts} />
                        ))
                    }

                    {/* <li className="fact">
                    <div className="fact-content">
                        <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        <a className="link-source" href="https://opensource.facebook.com" rel="noreferrer" target="_blank"> (Source) </a>
                        </p>
                        <span className="tag" style="background-color: red;">[#Technology#]</span>
                    </div>
                    <div className="vote-buttons">
                        <button className="vote-button"> 👍 <strong>24</strong></button>
                        <button className="vote-button"> 🤯 <strong>9 </strong></button>
                        <button className="vote-button"> ⛔️ <strong>4 </strong></button>
                    </div>
                    </li>
                    <li className="fact">
                    <div className="fact-content">
                        <p>Dolorem harum debitis facilis earum voluptatibus dolorum, dolore nihil reprehenderit consequuntur!
                        <a className="link-source" href="https://www.google.com" rel="noreferrer" target="_blank"> (Source) </a>
                        </p>
                        <span className="tag" style="background-color: green;">[#Technology#]</span>
                    </div>
                    <div className="vote-buttons">
                        <button className="vote-button"> 👍 <strong>24</strong></button>
                        <button className="vote-button"> 🤯 <strong>9 </strong></button>
                        <button className="vote-button"> ⛔️ <strong>4 </strong></button>
                    </div>
                    </li>
                    <li className="fact">
                    <div className="fact-content">
                        <p>Adipisicing elit. Dolorem harum debitis facilis
                        <a className="link-source" href="https://www.wikipedia.org"rel="noreferrer"  target="_blank"> (Source) </a>
                        </p>
                        <span className="tag" style="background-color: red;">[#Society#]</span>
                    </div>
                    <div className="vote-buttons">
                        <button className="vote-button"> 👍 <strong>24</strong></button>
                        <button className="vote-button"> 🤯 <strong>9 </strong></button>
                        <button className="vote-button"> ⛔️ <strong>4 </strong></button>
                    </div>
                    </li>
                    <li className="fact">
                    <div className="fact-content">
                        <p>Debitis facilis earum
                        <a className="link-source" href="https://www.google.com" rel="noreferrer" target="_blank"> (Source) </a>
                        </p>
                    </div>
                    <span className="tag" style="background-color: orange;">[#Technology#]</span>
                    <div className="vote-buttons">
                        <button className="vote-button"> 👍 <strong>24</strong></button>
                        <button className="vote-button"> 🤯 <strong>9 </strong></button>
                        <button className="vote-button"> ⛔️ <strong>4 </strong></button>
                    </div>

                    </li>
                    <li className="fact">
                    <div className="fact-content">
                        <p>Harum debitis facilis earum voluptatibus dolorum, dolore nihil reprehender
                        <a className="link-source" href="https://www.cnn.com" rel="noreferrer" target="_blank"> (Source) </a>
                        </p>
                        <span className="tag" style="background-color: red;">[#Society#]</span>
                    </div>
                    <div className="vote-buttons">
                        <button className="vote-button"> 👍 <strong>24</strong></button>
                        <button className="vote-button"> 🤯 <strong>9 </strong></button>
                        <button className="vote-button"> ⛔️ <strong>4 </strong></button>
                    </div>
                    </li> */}
                </ul>
                </section>
            </>
        );
    }
}
  
export default FactList;